import type { Job } from "@stryker/core/types/jobs";
import { Typography } from "@/components/ui/typography";
import { cn } from "@/lib/utils";

type JobStatusProps = {
  className?: string;
  innerContainerClassName?: string;
  status?: Job["job_status"] | string;
};

type StatusKey = Job["job_status"] | "Approved" | "Rejected" | "Not Started";

export default function Status({ status, className, innerContainerClassName }: JobStatusProps) {
  if (!status) return null;
  const bg: Record<StatusKey, string> = {
    Completed: "bg-success-200",
    Created: "bg-success-200",
    Custom: "bg-gray-100",
    Approved: "bg-success-200",
    "In Progress": "bg-blue-200",
    FAILED: "bg-error-200",
    Rejected: "bg-error-200",
    DRAFT: "bg-primary-200",
    "Not Started": "bg-primary-200",
  };
  const color: Record<StatusKey, string> = {
    Completed: "text-success-700",
    Created: "text-success-700",
    Approved: "text-success-700",
    "In Progress": "text-blue-700",
    FAILED: "text-error-700",
    Rejected: "text-error-700",
    DRAFT: "text-blue-700",
    Custom: "text-gray-500",
    "Not Started": "text-blue-700",
  };
  return (
    <div className={cn("flex justify-center", className)}>
      <div
        className={cn(
          "flex h-6 w-24 items-center justify-center rounded-md px-2",
          status && bg[status as StatusKey],
          innerContainerClassName
        )}
      >
        <Typography variant="text-small" weight="medium" className={cn(status && color[status as StatusKey])}>
          {status}
        </Typography>
      </div>
    </div>
  );
}
